import { render } from "./TaiXeGiaoNhanHang.vue?vue&type=template&id=2d0bdca2&scoped=true"
import script from "./TaiXeGiaoNhanHang.vue?vue&type=script&lang=js"
export * from "./TaiXeGiaoNhanHang.vue?vue&type=script&lang=js"

import "./TaiXeGiaoNhanHang.vue?vue&type=style&index=0&id=2d0bdca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0bdca2"]])

export default __exports__